import { Controller } from '@hotwired/stimulus'
import { turboRequest } from '../../../helpers/turbo_helper'

export default class extends Controller {
  static targets = ['month']
  static values = {
    url: String
  }

  change(event) {
    turboRequest(`${this.urlValue}?report_month=${event.target.value}`)
  }
}
